import * as ACTIONS from "@iso/redux/menu/actionTypes";

const initialState = {
  menus: {
    list: [],
    total: 0,
  },
};

function menuReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_MENUS_SUCCESS: {
      return {
        ...state,
        ...{ menus: payload },
      };
    }

    default:
      return state;
  }
}

export default menuReducer;
